import { isDevServer, isDevServerBooted } from '@tytapp/environment-utils';

/**
 * When applied to a dialog component class, this prevents the application
 * from dismissing the dialog when a navigation occurs (see the route event
 * handling in the Shell class).
 *
 * @returns
 */
export function GlobalDialog() {
    return (target) => {
            if (Reflect.defineMetadata) {
                Reflect.defineMetadata('dialog:global', true, target);
            } else {
                if (!isDevServer() || isDevServerBooted()) {
                    if (isDevServer()) {
                        console.error(`Error: Running in dev server and reflect-metadata is not loaded! TYT.com may not function correctly!`);
                        console.error(`  * In Angular Dev Server, special handling is needed to ensure TYT.com `);
                        console.error(`    works correctly. Please ensure the following options are set for the `);
                        console.error(`    current Angular CLI build configuration (ie: 'foobar' in `);
                        console.error(`    'ng build -c foobar').`);
                        console.error(`    - "outputMode": "server"`);
                        console.error(`    - "ssr": { "entry": "server.ts" }`);
                    } else {
                        // TODO: This fires off during builds, but shouldn't:
                        // console.error(`Error: reflect-metadata is not loaded! TYT.com may not function correctly!`);
                        // console.error(`  * It should have been loaded in main.ts!`);
                    }
                }
            }
        };
}